import { ExternalLink } from "@/components/ExternalLink";
import i18n from "@/i18n";
import { formatNumber } from "@/features/Table/utils";
import { parseDate } from "@/lib/utils";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
import { Tables } from "@/gen/tableNames/tables";
import { Clients } from "@/lib/clients";

// import { getAuditColumns } from "@/features/Audit/getAuditColumns";

export type S3TimeSerie = {
  id: number;
  date: string;
  s3_static_datum_name: string;
  s3_static_datum_id?: number;

  fixing: number;
  market_value: number;
  devise: string;
};

const t = (key: string, defaultValue: string) =>
  i18n.t(`${Tables.S3_TIME_SERIES}.columns.${key}`, {
    ns: "tables",
    defaultValue,
  });

export const columns: ColumnDef<S3TimeSerie>[] = [
  {
    accessorKey: "id",
    header: t("id", "ID"),
  },
  {
    accessorKey: "date",
    header: t("date", "Date"),
    cell: ({ row }) => {
      return parseDate(row.getValue("date"));
    },
  },
  {
    accessorKey: "s3_static_datum_name",
    header: t("s3_static_datum_name", "Asset"),
    cell: ({ row }) => {
      return (
        <ExternalLink
          href={toWorkspacePath(
            `/admin/${Clients.S3}/${Tables.S3_STATIC_DATA}/${row.original.s3_static_datum_id}`,
          )}
          className="text-xs lg:whitespace-nowrap"
          underline="hover"
        >
          {row.getValue("s3_static_datum_name")}
        </ExternalLink>
      );
    },
  },
  {
    accessorKey: "fixing",
    header: () => <div className="text-right">{t("fixing", "Fixing")}</div>,
    cell: ({ row }) => {
      const value = row.getValue("fixing") as number;
      const formattedValue =
        value === null || value === undefined || Number.isNaN(value)
          ? ""
          : new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 5,
              maximumFractionDigits: 5,
            }).format(value);

      return <div className="text-right">{formattedValue}</div>;
    },
  },
  {
    accessorKey: "market_value",
    header: () => (
      <div className="text-right">{t("market_value", "Market value")}</div>
    ),
    cell: ({ row }) => {
      return (
        <div className="text-right">
          {formatNumber(row.getValue("market_value"))}
        </div>
      );
    },
  },
  {
    accessorKey: "currency",
    header: t("currency", "Currency"),
  },
  {
    id: "actions",
    header: () => <div className="text-right">{t("actions", "Actions")}</div>,
    cell: ({ row }) => {
      return (
        <div className="flex justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];

// export const porfolios_audit_columns = getAuditColumns<S3TimeSerie>(porfolios_columns)
